import AccountAgrotechClassPartnerForm from './AccountAgrotechClassPartnerForm'
import { ApiService, Form } from '~/shared/api'
import { isUnknownObject } from '~/shared/utils/guards'
import { RequestService } from '~/services/RequestService'
import { RequestException } from '~/types/exceptions'
import { AgrotechClassPartnerModel, AgrotechClassPartnerSpecializationModel } from '~/model/AccountAgrotechClassPartner'

class SavePartnerForm extends Form {
  constructor(payload: object) {
    super()
    Object.assign(this, payload)
    this.setSendAs('form-data')
    this.setMethod('POST')
  }
}

class AccountAgrotechClassPartnerService extends ApiService {
  protected route: string = 'users-management/industrial-partner'
  protected specializationsRoute: string = 'industrial-partners/specializations'

  constructor(requestService: RequestService) {
    super(requestService)
  }

  private get url(): string {
    return `${this.prefix}/${this.route}`
  }

  public getCurrentPartner(): Promise<AgrotechClassPartnerModel | null> {
    return this.requestService
      .request<{ data?: unknown }>({ url: this.url, _silent: true })
      .then(({ data }) => new AgrotechClassPartnerModel(isUnknownObject(data) ? data.data : null))
      .catch(err => {
        if (err instanceof RequestException && err.internalError.status === 404) {
          return null
        }

        throw err
      })
  }

  public getSpecializations(search?: string): Promise<AgrotechClassPartnerSpecializationModel[]> {
    return this.requestService
      .request<{ result?: unknown }>({
        url: `${this.prefix}/${this.specializationsRoute}`,
        params: search ? { search } : undefined
      })
      .then(({ data }) => {
        const result = isUnknownObject(data) ? data.result : null
        return Array.isArray(result) ? result.map(i => new AgrotechClassPartnerSpecializationModel(i)) : []
      })
  }

  public save(form: AccountAgrotechClassPartnerForm): Promise<AgrotechClassPartnerModel> {
    const payload = new SavePartnerForm(form.toInputData())

    return this.requestService
      .request<{ data?: unknown }>({
        url: this.url,
        method: payload.getMethod(),
        data: payload.serialize(),
        _silent: true
      })
      .then(({ data }) => new AgrotechClassPartnerModel(isUnknownObject(data) ? data.data : null))
  }
}

export default AccountAgrotechClassPartnerService
